<template>
    <div class="rd">
        <div class="pagina">
            <div class="inlog-wrap">
                <form class="paneel inlog-kaart" novalidate @submit.prevent="savePassword">
                    <img src="/x-cube-logo.png" alt="X-Cube" class="inlog-logo" />
                    <h1>Confirm account</h1>
                    <p class="muted" style="margin:0 0 8px">Choose a password to finish your registration and get access to your location's bookings and settings.</p>

                    <div class="veld">
                        <label for="cf-pw">Password</label>
                        <input
                            id="cf-pw"
                            v-model="model.password"
                            type="password"
                            autocomplete="new-password"
                            minlength="5"
                            maxlength="32"
                            @input="error = ''"
                        />
                    </div>
                    <div class="veld">
                        <label for="cf-pw2">Confirm password</label>
                        <input
                            id="cf-pw2"
                            v-model="model.confirmPassword"
                            type="password"
                            autocomplete="new-password"
                            minlength="5"
                            maxlength="32"
                            :aria-invalid="!!error"
                            @input="error = ''"
                        />
                        <span class="fout">{{ error }}</span>
                    </div>

                    <button class="btn btn-pink" type="submit" style="width:100%" :disabled="loading">
                        {{ loading ? "Saving…" : "Confirm password" }}
                    </button>

                    <div class="inlog-links">
                        <router-link class="linkknop" to="/login">Back to login</router-link>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router/composables";
import { confirmManagedUser } from "../../api/rest";
import { Message } from "element-ui";

const router = useRouter();
const route = useRoute();

const token = route.params.token;
const loading = ref(false);
const error = ref("");
const model = ref({
    password: "",
    confirmPassword: "",
});

const savePassword = async () => {
    if (model.value.password.length < 5) {
        error.value = "Use at least 5 characters.";
        return;
    }
    if (model.value.password !== model.value.confirmPassword) {
        error.value = "Passwords do not match";
        return;
    }
    try {
        loading.value = true;
        await confirmManagedUser(token, model.value.password);
        Message.success("Successfully registered account");
        router.push({ name: "login" });
    } catch (e) {
        Message.error(e instanceof Error ? e.message : "Could not confirm your account");
    } finally {
        loading.value = false;
    }
};
</script>
